// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"984a9957","119":"7d1478b6","133":"67ba3544","165":"17e41189","315":"312a3cb8","335":"74b828c9","815":"e07400ec"}[chunkId] + ".chunk.js";
};